var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flatfinder',{staticClass:"residential-flatfinder",attrs:{"value":_vm.value,"properties":_vm.properties,"preventNavigation":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }